import {
  FETCH_CURRENT_USER_PROFILE_REQUEST,
  FETCH_CURRENT_USER_PROFILE_SUCCESS,
  FETCH_CURRENT_USER_PROFILE_FAIL,
  UPDATE_USER_PROFILE_REQUEST,
  UPDATE_USER_PROFILE_SUCCESS,
  UPDATE_USER_PROFILE_FAIL,
  UPDATE_USER_INFO_REQUEST,
  UPDATE_USER_INFO_SUCCESS,
  UPDATE_USER_INFO_FAIL,
  UPDATE_USER_PROFILE_ONLY_REQUEST,
  UPDATE_USER_PROFILE_ONLY_SUCCESS,
  UPDATE_USER_PROFILE_ONLY_FAIL,
  FETCH_USER_PROFILE_BY_ID_REQUEST,
  FETCH_USER_PROFILE_BY_ID_SUCCESS,
  FETCH_USER_PROFILE_BY_ID_FAIL,
  FETCH_USER_PROFILE_BY_USERNAME_REQUEST,
  FETCH_USER_PROFILE_BY_USERNAME_SUCCESS,
  FETCH_USER_PROFILE_BY_USERNAME_FAIL,
  RESET_USER_PROFILE_ERROR,
} from "./userProfileTypes";
import { mergeUserPatch } from "./mergeUserUpdate";

const initialState = {
  currentUserProfile: null,
  viewedProfile: null,
  loadingCurrent: false,
  loadingUpdate: false,
  loadingView: false,
  error: null,
};

export const userProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CURRENT_USER_PROFILE_REQUEST:
      return {
        ...state,
        loadingCurrent: true,
        error: null,
      };
    case FETCH_CURRENT_USER_PROFILE_SUCCESS:
      return {
        ...state,
        loadingCurrent: false,
        currentUserProfile: action.payload,
      };
    case FETCH_CURRENT_USER_PROFILE_FAIL:
      return {
        ...state,
        loadingCurrent: false,
        error: action.payload,
      };

    case UPDATE_USER_PROFILE_REQUEST:
    case UPDATE_USER_INFO_REQUEST:
    case UPDATE_USER_PROFILE_ONLY_REQUEST:
      return {
        ...state,
        loadingUpdate: true,
        error: null,
      };
    case UPDATE_USER_PROFILE_SUCCESS: {
      const payload = action.payload?.body ?? action.payload;
      const updated = payload?.updated;
      const prev = state.currentUserProfile?.body ?? state.currentUserProfile;
      const nextProfile =
        updated?.user || updated?.profile
          ? {
              body: {
                user: { ...prev?.user, ...updated?.user },
                profile: { ...prev?.profile, ...updated?.profile },
              },
            }
          : action.payload;
      return {
        ...state,
        loadingUpdate: false,
        currentUserProfile: nextProfile,
      };
    }
    case UPDATE_USER_INFO_SUCCESS: {
      const payload = action.payload?.body ?? action.payload;
      const userUpdates = payload?.user;
      const prev = state.currentUserProfile?.body ?? state.currentUserProfile;
      const next =
        userUpdates && prev?.user
          ? {
              body: {
                user: mergeUserPatch(prev.user, userUpdates),
                profile: prev.profile,
              },
            }
          : action.payload;
      return {
        ...state,
        loadingUpdate: false,
        currentUserProfile: next,
      };
    }
    case UPDATE_USER_PROFILE_ONLY_SUCCESS: {
      const payload = action.payload?.body ?? action.payload;
      const profileUpdates = payload?.profile;
      const prev = state.currentUserProfile?.body ?? state.currentUserProfile;
      const next =
        profileUpdates && prev
          ? {
              body: {
                user: prev.user,
                profile: { ...prev.profile, ...profileUpdates },
              },
            }
          : action.payload;
      return {
        ...state,
        loadingUpdate: false,
        currentUserProfile: next,
      };
    }
    case UPDATE_USER_PROFILE_FAIL:
    case UPDATE_USER_INFO_FAIL:
    case UPDATE_USER_PROFILE_ONLY_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload,
      };

    case FETCH_USER_PROFILE_BY_ID_REQUEST:
    case FETCH_USER_PROFILE_BY_USERNAME_REQUEST:
      return {
        ...state,
        loadingView: true,
        error: null,
      };
    case FETCH_USER_PROFILE_BY_ID_SUCCESS:
    case FETCH_USER_PROFILE_BY_USERNAME_SUCCESS:
      return {
        ...state,
        loadingView: false,
        viewedProfile: action.payload,
      };
    case FETCH_USER_PROFILE_BY_ID_FAIL:
    case FETCH_USER_PROFILE_BY_USERNAME_FAIL:
      return {
        ...state,
        loadingView: false,
        error: action.payload,
      };

    case RESET_USER_PROFILE_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
